import { useState } from 'react';

const useToggle = (): [boolean, () => void] => {
  const [value, set] = useState(false);
  const toggle = () => set(!value);
  return [value, toggle];
};

export default useToggle;
